import { useState } from 'react';
import axios from 'axios';

function useFileUploader() {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [percent, setPercent] = useState(0);
  const [response, setResponse] = useState(null);

  const onProgressHandler = progressEvent => {
    setPercent(Math.round((progressEvent.loaded * 100) / progressEvent.total));
  };

  const startUpload = ({ url, file, headers }) => {
    const upload = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = new FormData();
        data.append('file', file, file.name);
        const { data: apiResponse } = await axios.post(url, data, {
          headers: { ...headers },
          timeout: 60000,
          onUploadProgress: onProgressHandler
        });
        setResponse(apiResponse);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    if (!loading) {
      upload();
    }
  };
  return { loading, percent, response, error, startUpload };
}

export { useFileUploader };
